import { SimpleModal } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'
import { automationsPaths } from 'Automations/router'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const NoContractAutomationModal = ({ isOpen, onClose }: Props) => {
  const navigate = useNavigate()

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      variant="dialog"
      title="No contract intake automation configured"
      submitButtonText="Set up automation"
      cancelButtonText="Dismiss"
      data-testid="noContractWorkflow.modal"
      onSubmit={() => {
        navigate(automationsPaths.automationsList())
        return true
      }}
    >
      Contract uploads require an active contract intake automation. Set one up
      in the Automations page to get started.
    </SimpleModal>
  )
}
